import { simpleSet } from '@r/reducers/utils';

const setShowCurrentItem = simpleSet as redux.reducers.flags.showCurrentItem;
export const showCurrentItem = setShowCurrentItem(
  'SET_SHOW_CURRENT_ITEM',
  false
);
